"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNIT = exports.PROJECTED_PIXEL_SIZE_MULTIPLIER = void 0;

/**
 * A multiplier for screen-space width/scale for Arc, Line, Icon and Text layers.
 * Required in order to maintain the same appearance after upgrading to deck.gl v8.5.
 * https://github.com/visgl/deck.gl/blob/master/docs/upgrade-guide.md
 */
var PROJECTED_PIXEL_SIZE_MULTIPLIER = 2 / 3;
/**
 * Unit literal to shader unit number conversion.
 */

exports.PROJECTED_PIXEL_SIZE_MULTIPLIER = PROJECTED_PIXEL_SIZE_MULTIPLIER;
var UNIT = {
  common: 0,
  meters: 1,
  pixels: 2
};
exports.UNIT = UNIT;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jb25zdGFudHMudHMiXSwibmFtZXMiOlsiUFJPSkVDVEVEX1BJWEVMX1NJWkVfTVVMVElQTElFUiIsIlVOSVQiLCJjb21tb24iLCJtZXRlcnMiLCJwaXhlbHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7Ozs7QUFLTyxJQUFNQSwrQkFBK0IsR0FBRyxJQUFJLENBQTVDO0FBRVA7Ozs7O0FBR08sSUFBTUMsSUFBSSxHQUFHO0FBQ2xCQyxFQUFBQSxNQUFNLEVBQUUsQ0FEVTtBQUVsQkMsRUFBQUEsTUFBTSxFQUFFLENBRlU7QUFHbEJDLEVBQUFBLE1BQU0sRUFBRTtBQUhVLENBQWIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEEgbXVsdGlwbGllciBmb3Igc2NyZWVuLXNwYWNlIHdpZHRoL3NjYWxlIGZvciBBcmMsIExpbmUsIEljb24gYW5kIFRleHQgbGF5ZXJzLlxuICogUmVxdWlyZWQgaW4gb3JkZXIgdG8gbWFpbnRhaW4gdGhlIHNhbWUgYXBwZWFyYW5jZSBhZnRlciB1cGdyYWRpbmcgdG8gZGVjay5nbCB2OC41LlxuICogaHR0cHM6Ly9naXRodWIuY29tL3Zpc2dsL2RlY2suZ2wvYmxvYi9tYXN0ZXIvZG9jcy91cGdyYWRlLWd1aWRlLm1kXG4gKi9cbmV4cG9ydCBjb25zdCBQUk9KRUNURURfUElYRUxfU0laRV9NVUxUSVBMSUVSID0gMiAvIDM7XG5cbi8qKlxuICogVW5pdCBsaXRlcmFsIHRvIHNoYWRlciB1bml0IG51bWJlciBjb252ZXJzaW9uLlxuICovXG5leHBvcnQgY29uc3QgVU5JVCA9IHtcbiAgY29tbW9uOiAwLFxuICBtZXRlcnM6IDEsXG4gIHBpeGVsczogMixcbn07XG4iXX0=